import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Result } from '@/reservation/reservation.model';
import { Segment } from '@/bag/transport-segments/transport-segments.model';
import { inject } from '@angular/core';
import { TransportTermList } from '@/bag/bag-transport-term/bag-transport-term.model';

interface OrganizationStatus {
	id: number;
	name: string;
}

@Injectable({
	providedIn: 'root',
})
export class TransportSegmentsApiService {
	private readonly httpClient = inject(HttpClient);
	private readonly apiUrl = environment.apiUrl;

	getSegments(limit: number, offset: number): Observable<Result<Segment>> {
		return this.httpClient.get<Result<Segment>>(
			`${this.apiUrl}/transport/segments/?limit=${limit}&offset=${offset}`,
		);
	}

	getSegment(id: number): Observable<Segment> {
		return this.httpClient.get<Segment>(`${this.apiUrl}/transport/segments/${id}/`);
	}

	getTransportTermsBySegment(segmentId: number): Observable<Result<TransportTermList>> {
		return this.httpClient.get<Result<TransportTermList>>(
			`${this.apiUrl}/transport/transport_term/?segment=${segmentId}`,
		);
	}

	getOrganizationStatuses(): Observable<Result<OrganizationStatus>> {
		return this.httpClient.get<Result<OrganizationStatus>>(
			`${this.apiUrl}/transport/transport_term_organization_status/?limit=999`,
		);
	}

	getTransportTerms(filters: {
		search?: string;
		accommodation_after?: string;
		accommodation_before?: string;
	}): Observable<Result<TransportTermList>> {
		let params = new HttpParams().set('limit', 999);
		if (filters.search) {
			params = params.set('search', filters.search);
		}
		if (filters.accommodation_after) {
			params = params.set('accommodation_after', filters.accommodation_after);
		}
		if (filters.accommodation_before) {
			params = params.set('accommodation_before', filters.accommodation_before);
		}
		return this.httpClient.get<Result<TransportTermList>>(`${this.apiUrl}/transport/transport_term/`, { params });
	}

	createSegment(payload: { name: string; transportTerms: number[] }): Observable<Segment> {
		return this.httpClient.post<Segment>(`${this.apiUrl}/transport/segments/`, payload);
	}

	updateSegment(id: number, payload: { name: string; transportTerms: number[] }): Observable<Segment> {
		return this.httpClient.put<Segment>(`${this.apiUrl}/transport/segments/${id}/`, payload);
	}
}
